module.exports = __webpack_public_path__ + "img/w3.2c060574.png";